export default {
    integer: /^\d+$/,
    email: /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/,
    mobile: /^1\d{10}$/,
    landline: /^\d{3,4}-?\d{7,9}$/,
    telephone: /(^1\d{10}$)|(^\d{3,4}-?\d{7,9}$)/,
    date: /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
    idcard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
}